import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useUser } from '@/hooks/use-user';
import { identifyMixpanelUser, registerSuperProperties } from '@/lib/mixpanel';

export type MixpanelUserType = 'choose' | 'brand';

function resolveUserType(
  isInternalUser: boolean | undefined
): MixpanelUserType {
  return isInternalUser ? 'choose' : 'brand';
}

function getBrowserLanguage(): string | undefined {
  if (typeof navigator === 'undefined') return undefined;
  return navigator.language;
}

export function useMixpanelIdentify(): void {
  const user = useUser();
  const { i18n } = useTranslation();
  const sub = user?.providerUser?.sub;
  const email = user?.providerUser?.email;
  const name = user?.providerUser?.name;
  const isInternalUser = user?.isInternalUser;
  const isDeveloper = user?.isDeveloper;
  const role = user?.role;
  const browserLanguage = getBrowserLanguage();
  const interfaceLanguage = i18n.language;

  useEffect(() => {
    if (!sub) return;

    const userType = resolveUserType(isInternalUser);

    registerSuperProperties({
      userType,
      isDeveloper,
      browserLanguage,
      interfaceLanguage,
    });

    identifyMixpanelUser(sub, {
      $email: email,
      $name: name,
      isInternalUser,
      isDeveloper,
      role,
      userType,
      browserLanguage,
      interfaceLanguage,
    });
  }, [
    sub,
    email,
    name,
    isInternalUser,
    isDeveloper,
    role,
    browserLanguage,
    interfaceLanguage,
  ]);
}
